import React from "react";
import Navbar from "../components/Navbar";
import "../App.css";
import bg from "../assets/bg.svg";

const sections = [
    {
        title: "Toplanan ve Islenen Veriler",
        intro: "Uygulama asagidaki verileri isleyebilir:",
        items: [
            "kullanici kimlik bilgileri",
            "ad soyad",
            "kullanici adi",
            "e-posta bilgisi",
            "magaza ve kullaniciya bagli operasyonel bilgiler",
            "cihaz bilgileri",
            "cihaz veya diger uygulama kimlikleri",
            "uygulama servis yapilandirma bilgileri",
            "bildirim token bilgileri",
            "kullanici tarafindan yuklenen profil fotografi",
            "form veya gorev kapsaminda kullanici tarafindan eklenen gorseller",
            "uygulama icinde okutulan barkod, stok ve operasyon verileri",
            "teknik hata ve islem kayitlari",
        ],
    },
    {
        title: "Cihaz ve Diger Kimlikler",
        body: "Uygulama; cihaz kaydi, cihaz-kullanici eslestirme, oturum guvenligi, bildirim gonderimi ve uygulama islevlerinin dogru calismasi amaciyla cihaza veya uygulamaya ozgu bazi tanimlayicilari isleyebilir.",
        note: "Bu veriler; cihaz benzersiz kimligi, bildirim token bilgisi, uygulama kurulumuna iliskin teknik tanimlayicilar ve benzeri cihaz veya uygulama kimliklerini icerebilir. Bu veriler; kullanici girisi, hesap yonetimi, cihaz guvenligi, dolandiriciligi onleme, teknik destek, bildirim gonderimi ve uygulama ici operasyonel sureclerin yurutulmesi amaciyla kullanilabilir.",
    },
    {
        title: "Kamera Izni",
        intro: "Uygulama kamera iznini asagidaki amaclarla kullanabilir:",
        items: [
            "barkod okutma islemleri",
            "urun ve raf operasyonlari",
            "profil fotografi cekme",
            "form veya gorevlerde gorsel ekleme",
        ],
        note: "Kamera yalnizca kullanici tarafindan ilgili islem baslatildiginda kullanilir.",
    },
    {
        title: "Fotograflar ve Gorseller",
        body: "Kullanici, profil fotografi yuklemek veya uygulama icindeki form ve gorev sureclerinde gorsel eklemek icin fotograf secimi ya da kamera cekimi yapabilir. Bu gorseller yalnizca ilgili uygulama islevinin saglanmasi amaciyla islenir.",
    },
    {
        title: "Bildirimler",
        body: "Uygulama, gorevler, hatirlatmalar, formlar ve operasyonel bilgilendirmeler icin push bildirim gonderebilir. Bunun icin cihaz bildirim token bilgisi islenebilir.",
    },
    {
        title: "Verilerin Kullanim Amaclari",
        intro: "Toplanan veriler su amaclarla kullanilabilir:",
        items: [
            "kullanici girisi ve yetkilendirme",
            "hesap yonetimi",
            "cihaz eslestirme ve guvenlik kontrolleri",
            "magaza ve gorev bazli operasyonlarin yurutulmesi",
            "formlarin, raporlarin ve stok sureclerinin yonetilmesi",
            "bildirimlerin iletilmesi",
            "uygulama performansinin ve guvenliginin izlenmesi",
            "teknik hata analizi ve destek surecleri",
        ],
    },
    {
        title: "Veri Aktarimi",
        body: "Uygulama tarafindan islenen kullanici verileri, hizmetin sunulmasi amaciyla kullanici cihazinin disindaki yetkili sunuculara guvenli baglantilar uzerinden aktarilabilir. Aktarilan veriler; kimlik dogrulama, cihaz kaydi, bildirim yonetimi, gorev ve form islemleri, raporlama, stok ve operasyon sureclerinin yurutulmesi icin kullanilabilir.",
    },
    {
        title: "Veri Paylasimi",
        body: "Veriler, yalnizca hizmetin sunulmasi, guvenlik, teknik destek ve kurumsal operasyonlarin yurutulmesi amaciyla yetkili sistemler ve hizmet saglayicilarla paylasilabilir. Veriler, yasal zorunluluklar disinda yetkisiz ucuncu kisilerle paylasilmaz.",
    },
    {
        title: "Veri Guvenligi",
        body: "Sportive Saha, islenen verilerin korunmasi icin makul teknik ve idari guvenlik onlemleri uygular. Kullanici verileri aktarim sirasinda guvenli baglantilar uzerinden iletilir. Buna ragmen internet uzerinden yapilan veri iletimlerinin tamamen risksiz oldugu garanti edilemez.",
    },
    {
        title: "Veri Saklama",
        body: "Veriler, isleme amacinin gerektirdigi sure boyunca veya ilgili mevzuat kapsaminda gerekli olan sure kadar saklanabilir.",
    },
    {
        title: "Kullanici Haklari",
        body: "Kullanicilar, gecerli mevzuat kapsaminda kisisel verileriyle ilgili bilgi talep etme, duzeltme ve gerekli durumlarda silme taleplerini iletebilir.",
    },
    {
        title: "Iletisim",
        body: "Bu gizlilik politikasi veya kisisel veri talepleriyle ilgili sorular icin asagidaki iletisim kanali kullanilabilir:",
        note: "E-posta: helpdesk@sportive.com.tr",
    },
];

export default function SportiveSahaGizlilikPolitikasi() {
    return (
        <div
            className="sportive-saha-privacy-page"
            style={{
                minHeight: "100vh",
                backgroundImage: `url(${bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Navbar />

            <main
                style={{
                    flex: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    padding: "36px 16px",
                }}
            >
                <article
                    style={{
                        width: "100%",
                        maxWidth: "900px",
                        backgroundColor: "white",
                        borderRadius: "20px",
                        border: "8px solid white",
                        boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "#1b2833",
                            color: "#fff",
                            padding: "32px",
                            borderRadius: "12px",
                            lineHeight: 1.65,
                        }}
                    >
                        <h1
                            style={{
                                textAlign: "center",
                                color: "#fff",
                                fontWeight: 800,
                                fontSize: "24px",
                                margin: "0 0 8px",
                            }}
                        >
                            Sportive Saha Mobil Uygulamasi Gizlilik Politikasi
                        </h1>

                        <p
                            style={{
                                textAlign: "center",
                                color: "#dfe8ee",
                                fontWeight: 700,
                                margin: "0 0 24px",
                            }}
                        >
                            Son guncelleme: 18 Mayis 2026
                        </p>

                        <p style={{ marginBottom: "22px" }}>
                            Sportive Saha mobil uygulamasi, kullanici deneyimini saglamak, uygulama guvenligini surdurmek ve uygulama ici operasyonel surecleri yurutmek amaciyla belirli verileri isler. Bu gizlilik politikasi, uygulama kapsaminda hangi verilerin islendigini ve ne amacla kullanildigini aciklar.
                        </p>

                        {sections.map((section) => (
                            <section key={section.title} style={{ marginTop: "22px" }}>
                                <h2
                                    style={{
                                        color: "#CDE200",
                                        fontSize: "18px",
                                        fontWeight: 700,
                                        margin: "0 0 8px",
                                    }}
                                >
                                    {section.title}
                                </h2>

                                {section.intro && <p style={{ margin: "0 0 8px" }}>{section.intro}</p>}
                                {section.body && <p style={{ margin: "0 0 8px" }}>{section.body}</p>}
                                {section.items && (
                                    <ul style={{ margin: "0 0 8px 20px", padding: 0 }}>
                                        {section.items.map((item) => (
                                            <li key={item}>{item}</li>
                                        ))}
                                    </ul>
                                )}
                                {section.note && <p style={{ margin: "8px 0 0" }}>{section.note}</p>}
                            </section>
                        ))}
                    </div>
                </article>
            </main>
        </div>
    );
}
